module.exports = __webpack_public_path__ + "img/corporate-competition-2024-schedule-open-group-finals.36139b10.png";